import { ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { SignIn } from "pages/SignIn";
import DriverLayout from "components/DriverLayout";
import { useAuth } from "contexts/AuthContext";
import { DRIVER_GROUP } from "constants/permissions";

interface Props {
  children: ReactElement
}

export const DriverPrivatePage = ({ children }: Props): ReactElement => {
  const isAuthenticated = localStorage.getItem("bearerToken")
  const { userGroups } = useAuth()

  if (!isAuthenticated) {
    return <SignIn/>
  }

  // Só contas do grupo Motorista acessam o painel do motorista - qualquer
  // outra conta que caia aqui (ex: digitando a URL direto) volta pro admin.
  // Defesa em profundidade na UI; a proteção real é o backend.
  if (!userGroups.includes(DRIVER_GROUP)) {
    return <Navigate to="/home" replace/>
  }

  return (
    <DriverLayout>
      {children}
    </DriverLayout>
  )
}
